// extracted by mini-css-extract-plugin
var _1 = "actions-M63Z5";
var _2 = "pagination-FJEKv";
export { _1 as "actions", _2 as "pagination" }
